<template>
  <div>
    <Table border :columns="columns1" :data="row" style="width:800px"></Table>
    <!-- <br />
    <Page
      :total="total"
      show-total
      @on-change="changePage"
      @on-page-size-change="changePagesize"
    /> -->
  </div>
</template>
<script>
export default {
  props: {
    row: Array,
  },
  data() {
    return {
      columns1: [
        // {
        //     title: '巡检计划ID',
        //     minWidth: 100,
        //     key: 'planId',
        //     align: 'center',
        //   },
        {
          title: "名称",
          key: "name",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
              const text = row.name;
              return (
                <span
                  style={{
                    color: row.state == 3 ? "red" : "",
                    "font-size": "14px",
                  }}
                >
                  {text}
                </span>
              );
          },
        },
        {
          title: "状态",
          key: "stateName",
          minWidth: 80,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.stateName;
            return (
              <span
                style={{
                  color: row.state == 3 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.remark;
            return (
              <span
                style={{
                  color: row.state == 3 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
      ],
      data1: [],
      total: this.total,
    };
  },
};
</script>